// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/subscription/payment.v2.proto (package no.jotta.openapi.subscription.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Language } from "../language_pb.js";
import { Int64Value } from "../../protobuf/wrappers_pb.js";
/**
 * @generated from enum no.jotta.openapi.subscription.v2.RecurringSubscriptionInterval
 */
export var RecurringSubscriptionInterval;
(function (RecurringSubscriptionInterval) {
    /**
     * @generated from enum value: NOT_SET_RECURRING = 0;
     */
    RecurringSubscriptionInterval[RecurringSubscriptionInterval["NOT_SET_RECURRING"] = 0] = "NOT_SET_RECURRING";
    /**
     * @generated from enum value: MONTHLY_RECURRING = 1;
     */
    RecurringSubscriptionInterval[RecurringSubscriptionInterval["MONTHLY_RECURRING"] = 1] = "MONTHLY_RECURRING";
    /**
     * @generated from enum value: YEARLY_RECURRING = 2;
     */
    RecurringSubscriptionInterval[RecurringSubscriptionInterval["YEARLY_RECURRING"] = 2] = "YEARLY_RECURRING";
})(RecurringSubscriptionInterval || (RecurringSubscriptionInterval = {}));
// Retrieve enum metadata with: proto3.getEnumType(RecurringSubscriptionInterval)
proto3.util.setEnumType(RecurringSubscriptionInterval, "no.jotta.openapi.subscription.v2.RecurringSubscriptionInterval", [
    { no: 0, name: "NOT_SET_RECURRING" },
    { no: 1, name: "MONTHLY_RECURRING" },
    { no: 2, name: "YEARLY_RECURRING" },
]);
/**
 * @generated from enum no.jotta.openapi.subscription.v2.SubscriptionInterval
 */
export var SubscriptionInterval;
(function (SubscriptionInterval) {
    /**
     * @generated from enum value: NOT_SET = 0;
     */
    SubscriptionInterval[SubscriptionInterval["NOT_SET"] = 0] = "NOT_SET";
    /**
     * @generated from enum value: MONTHLY = 1;
     */
    SubscriptionInterval[SubscriptionInterval["MONTHLY"] = 1] = "MONTHLY";
    /**
     * @generated from enum value: YEARLY = 2;
     */
    SubscriptionInterval[SubscriptionInterval["YEARLY"] = 2] = "YEARLY";
    /**
     * @generated from enum value: FIXED_1MND = 3;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_1MND"] = 3] = "FIXED_1MND";
    /**
     * @generated from enum value: FIXED_2MND = 4;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_2MND"] = 4] = "FIXED_2MND";
    /**
     * @generated from enum value: FIXED_3MND = 5;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_3MND"] = 5] = "FIXED_3MND";
    /**
     * @generated from enum value: FIXED_6MND = 6;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_6MND"] = 6] = "FIXED_6MND";
    /**
     * @generated from enum value: FIXED_12MND = 7;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_12MND"] = 7] = "FIXED_12MND";
    /**
     * @generated from enum value: FIXED_24MND = 8;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_24MND"] = 8] = "FIXED_24MND";
    /**
     * @generated from enum value: FIXED_36MND = 9;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_36MND"] = 9] = "FIXED_36MND";
    /**
     * @generated from enum value: FIXED_60MND = 10;
     */
    SubscriptionInterval[SubscriptionInterval["FIXED_60MND"] = 10] = "FIXED_60MND";
})(SubscriptionInterval || (SubscriptionInterval = {}));
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionInterval)
proto3.util.setEnumType(SubscriptionInterval, "no.jotta.openapi.subscription.v2.SubscriptionInterval", [
    { no: 0, name: "NOT_SET" },
    { no: 1, name: "MONTHLY" },
    { no: 2, name: "YEARLY" },
    { no: 3, name: "FIXED_1MND" },
    { no: 4, name: "FIXED_2MND" },
    { no: 5, name: "FIXED_3MND" },
    { no: 6, name: "FIXED_6MND" },
    { no: 7, name: "FIXED_12MND" },
    { no: 8, name: "FIXED_24MND" },
    { no: 9, name: "FIXED_36MND" },
    { no: 10, name: "FIXED_60MND" },
]);
/**
 * @generated from enum no.jotta.openapi.subscription.v2.Currency
 */
export var Currency;
(function (Currency) {
    /**
     * @generated from enum value: UNKNOWN_CURRENCY = 0;
     */
    Currency[Currency["UNKNOWN_CURRENCY"] = 0] = "UNKNOWN_CURRENCY";
    /**
     * @generated from enum value: DKK = 1;
     */
    Currency[Currency["DKK"] = 1] = "DKK";
    /**
     * @generated from enum value: EUR = 2;
     */
    Currency[Currency["EUR"] = 2] = "EUR";
    /**
     * @generated from enum value: NOK = 3;
     */
    Currency[Currency["NOK"] = 3] = "NOK";
    /**
     * @generated from enum value: SEK = 4;
     */
    Currency[Currency["SEK"] = 4] = "SEK";
    /**
     * @generated from enum value: USD = 5;
     */
    Currency[Currency["USD"] = 5] = "USD";
})(Currency || (Currency = {}));
// Retrieve enum metadata with: proto3.getEnumType(Currency)
proto3.util.setEnumType(Currency, "no.jotta.openapi.subscription.v2.Currency", [
    { no: 0, name: "UNKNOWN_CURRENCY" },
    { no: 1, name: "DKK" },
    { no: 2, name: "EUR" },
    { no: 3, name: "NOK" },
    { no: 4, name: "SEK" },
    { no: 5, name: "USD" },
]);
/**
 * @generated from message no.jotta.openapi.subscription.v2.Money
 */
export class Money extends Message {
    /**
     * amount is in smallest unit of currency, such as øre for kroner, and cents for USD.
     *
     * @generated from field: int64 amount = 1;
     */
    amount = protoInt64.zero;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Currency currency = 2;
     */
    currency = Currency.UNKNOWN_CURRENCY;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.Money";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 2, name: "currency", kind: "enum", T: proto3.getEnumType(Currency) },
    ]);
    static fromBinary(bytes, options) {
        return new Money().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Money().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Money().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Money, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PaymentInterval
 */
export class PaymentInterval extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 1;
     */
    interval = SubscriptionInterval.NOT_SET;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money price = 2;
     */
    price;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money price_before_discount = 3;
     */
    priceBeforeDiscount;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PaymentInterval";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 2, name: "price", kind: "message", T: Money },
        { no: 3, name: "price_before_discount", kind: "message", T: Money },
    ]);
    static fromBinary(bytes, options) {
        return new PaymentInterval().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaymentInterval().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaymentInterval().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaymentInterval, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CreateStripeIntentRequest
 */
export class CreateStripeIntentRequest extends Message {
    /**
     * optional payment_method from stripe if you have already gathered the card details.
     *
     * @generated from field: string payment_method = 1;
     */
    paymentMethod = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreateStripeIntentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateStripeIntentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateStripeIntentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateStripeIntentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateStripeIntentRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CreateStripeIntentResponse
 */
export class CreateStripeIntentResponse extends Message {
    /**
     * client_secret needed to initialize the Stripe handshake.
     *
     * @generated from field: string client_secret = 1;
     */
    clientSecret = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreateStripeIntentResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateStripeIntentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateStripeIntentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateStripeIntentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateStripeIntentResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.ChangePaymentRequest
 */
export class ChangePaymentRequest extends Message {
    /**
     * @generated from field: string payment_method = 1;
     */
    paymentMethod = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 2;
     */
    interval = SubscriptionInterval.NOT_SET;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ChangePaymentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
    ]);
    static fromBinary(bytes, options) {
        return new ChangePaymentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangePaymentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangePaymentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangePaymentRequest, a, b);
    }
}
/**
 * TODO: should we do error handling in response ?
 *
 * @generated from message no.jotta.openapi.subscription.v2.ChangePaymentResponse
 */
export class ChangePaymentResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ChangePaymentResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ChangePaymentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangePaymentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangePaymentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangePaymentResponse, a, b);
    }
}
/**
 * Vipps does not allow editing an existing agreement, so we can not support changing the billing interval directly
 * while on VippsBilling
 *
 * @generated from message no.jotta.openapi.subscription.v2.VippsBilling
 */
export class VippsBilling extends Message {
    /**
     * the vipps agreement is still active with Vipps
     *
     * @generated from field: bool is_active = 1;
     */
    isActive = false;
    /**
     * payment_ticket_id can be used to cancel this ticket
     *
     * @generated from field: string payment_ticket_id = 2;
     */
    paymentTicketId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.VippsBilling";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "payment_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new VippsBilling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VippsBilling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VippsBilling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VippsBilling, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.Card
 */
export class Card extends Message {
    /**
     * @generated from field: string card_mask = 1;
     */
    cardMask = "";
    /**
     * text of the card expire date like that on the card, such as '05/22'
     *
     * @generated from field: string card_expiry = 2;
     */
    cardExpiry = "";
    /**
     * @generated from field: string card_vendor = 3;
     */
    cardVendor = "";
    /**
     * @generated from field: int64 card_expires_at_millis = 4;
     */
    cardExpiresAtMillis = protoInt64.zero;
    /**
     * @generated from field: string payment_ticket_id = 5;
     */
    paymentTicketId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.Card";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "card_mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "card_expiry", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "card_vendor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "card_expires_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 5, name: "payment_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Card().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Card().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Card().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Card, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PayPal
 */
export class PayPal extends Message {
    /**
     * @generated from field: string payment_ticket_id = 1;
     */
    paymentTicketId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PayPal";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PayPal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PayPal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PayPal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PayPal, a, b);
    }
}
/**
 * NoPaymentMethod is a placeholder for empty/no payment method registered.
 *
 * @generated from message no.jotta.openapi.subscription.v2.NoPaymentMethod
 */
export class NoPaymentMethod extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.NoPaymentMethod";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new NoPaymentMethod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoPaymentMethod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoPaymentMethod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoPaymentMethod, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PaymentInfo
 */
export class PaymentInfo extends Message {
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.PaymentInfo.payment_method
     */
    paymentMethod = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PaymentInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "no_payment", kind: "message", T: NoPaymentMethod, oneof: "payment_method" },
        { no: 2, name: "card", kind: "message", T: Card, oneof: "payment_method" },
        { no: 6, name: "vipps_billing", kind: "message", T: VippsBilling, oneof: "payment_method" },
        { no: 7, name: "paypal", kind: "message", T: PayPal, oneof: "payment_method" },
    ]);
    static fromBinary(bytes, options) {
        return new PaymentInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaymentInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaymentInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaymentInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoRequest
 */
export class GetPaymentInfoRequest extends Message {
    /**
     * Optional parameter to override language for localized content.
     * This is mainly useful for apps that have a different language from the customer.language,
     * such as mobile apps that follow the OS language instead of the customer.language.
     *
     * @generated from field: no.jotta.openapi.Language language = 1;
     */
    language = Language.UNKNOWN_LANGUAGE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoRequest, a, b);
    }
}
/**
 * Display a message to offer customers that have an expiring subscription
 * with a partner to convert to Jottacloud.
 *
 * https://git.jotta.us/jotta/frontend/JXWebApp/-/blob/90568844afc07ccd2774ce57de500b140fe3c1c6/views-src/partials/settings_billing.ejs#L52
 * <p><%-__('Your BRAND subscription expires DATE due to your termination with NAME. The BRAND service is provided by Jottacloud. If you want to continue keeping your files and photos safely backed up, your BRAND account can LINK_START easily be converted to a Jottacloud accountLINK_END.', locals.brandTitle, moment((locals.subscription||{}).expireDate).format(__('DATE_LONG')), locals.brandName, locals.brandTitle, locals.brandTitle, '<a href="/web/convertTerm">','</a>')%></p>
 *
 * @generated from message no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer
 */
export class DueForTerminationConvertOffer extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DueForTerminationConvertOffer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DueForTerminationConvertOffer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DueForTerminationConvertOffer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DueForTerminationConvertOffer, a, b);
    }
}
/**
 * Your credit card is about to expire, you should LINK_START update your payment information LINK_END.
 *
 * @generated from message no.jotta.openapi.subscription.v2.CreditCardExpiresSoon
 */
export class CreditCardExpiresSoon extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreditCardExpiresSoon";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CreditCardExpiresSoon().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreditCardExpiresSoon().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreditCardExpiresSoon().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreditCardExpiresSoon, a, b);
    }
}
/**
 * Your credit card has expired, you should LINK_START update your payment information LINK_END.
 *
 * @generated from message no.jotta.openapi.subscription.v2.CreditCardExpired
 */
export class CreditCardExpired extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreditCardExpired";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CreditCardExpired().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreditCardExpired().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreditCardExpired().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreditCardExpired, a, b);
    }
}
/**
 * the subscription of the customer has some kind of payment issue
 *
 * @generated from message no.jotta.openapi.subscription.v2.HasPaymentIssues
 */
export class HasPaymentIssues extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.HasPaymentIssues";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new HasPaymentIssues().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HasPaymentIssues().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HasPaymentIssues().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HasPaymentIssues, a, b);
    }
}
/**
 * the subscription of the customer has expired
 *
 * @generated from message no.jotta.openapi.subscription.v2.HasExpiredSubscription
 */
export class HasExpiredSubscription extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.HasExpiredSubscription";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new HasExpiredSubscription().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HasExpiredSubscription().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HasExpiredSubscription().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HasExpiredSubscription, a, b);
    }
}
/**
 * info messages that should be rendered/displayed:
 *
 * @generated from message no.jotta.openapi.subscription.v2.SubscriptionMessage
 */
export class SubscriptionMessage extends Message {
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.SubscriptionMessage.message
     */
    message = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.SubscriptionMessage";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "due_for_termination_offer", kind: "message", T: DueForTerminationConvertOffer, oneof: "message" },
        { no: 2, name: "card_expires_soon", kind: "message", T: CreditCardExpiresSoon, oneof: "message" },
        { no: 3, name: "card_expired", kind: "message", T: CreditCardExpired, oneof: "message" },
        { no: 4, name: "payment_issue", kind: "message", T: HasPaymentIssues, oneof: "message" },
        { no: 5, name: "expired_subscription", kind: "message", T: HasExpiredSubscription, oneof: "message" },
    ]);
    static fromBinary(bytes, options) {
        return new SubscriptionMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubscriptionMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubscriptionMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubscriptionMessage, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse
 */
export class GetPaymentInfoResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.PaymentInfo payment_info = 1;
     */
    paymentInfo;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval subscription_interval = 2;
     */
    subscriptionInterval = SubscriptionInterval.NOT_SET;
    /**
     * @generated from field: string subscription_name_localized = 3;
     */
    subscriptionNameLocalized = "";
    /**
     * @generated from field: string product_name_localized = 4;
     */
    productNameLocalized = "";
    /**
     * @generated from field: string product_code = 22;
     */
    productCode = "";
    /**
     * @generated from field: int64 subscription_quota_bytes = 5;
     */
    subscriptionQuotaBytes = protoInt64.zero;
    /**
     * @generated from field: int64 subscription_usage_bytes = 6;
     */
    subscriptionUsageBytes = protoInt64.zero;
    /**
     * @generated from field: int64 customer_quota_bytes = 7;
     */
    customerQuotaBytes = protoInt64.zero;
    /**
     * @generated from field: int64 customer_usage_bytes = 8;
     */
    customerUsageBytes = protoInt64.zero;
    /**
     * @generated from field: no.jotta.protobuf.Int64Value renewal_date_millis = 9;
     */
    renewalDateMillis;
    /**
     * @generated from field: no.jotta.protobuf.Int64Value expiration_date_millis = 10;
     */
    expirationDateMillis;
    /**
     * a value of 10 means 10% discount
     *
     * @generated from field: int32 discount_percentage = 11;
     */
    discountPercentage = 0;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money price = 12;
     */
    price;
    /**
     * Display button for downgrade account.
     *
     * @generated from field: bool can_downgrade = 14;
     */
    canDowngrade = false;
    /**
     * Display button for applying voucher, ie. "I have a code".
     *
     * @generated from field: bool can_use_voucher = 15;
     */
    canUseVoucher = false;
    /**
     * Payment intervals the customer can change to, and their price.
     * Empty list means no possibility to change interval.
     *
     * @generated from field: repeated no.jotta.openapi.subscription.v2.PaymentInterval possible_payment_intervals = 16;
     */
    possiblePaymentIntervals = [];
    /**
     * any credit the customer could have
     *
     * @generated from field: no.jotta.openapi.subscription.v2.Money credit = 17;
     */
    credit;
    /**
     * notification type messages that should be displayed to the customer
     * such as a notification that your credit card has expired.
     *
     * @generated from field: repeated no.jotta.openapi.subscription.v2.SubscriptionMessage subscription_messages = 18;
     */
    subscriptionMessages = [];
    /**
     * @generated from field: int64 free_storage_limit = 19;
     */
    freeStorageLimit = protoInt64.zero;
    /**
     * The number of family members in the family/home account, or 0 for non-family accounts.
     * This is in additional to the family owner.
     *
     * @generated from field: int32 num_family_members = 20;
     */
    numFamilyMembers = 0;
    /**
     * @generated from field: optional uint64 extra_storage_bytes = 21;
     */
    extraStorageBytes;
    /**
     * @generated from field: optional uint32 extra_seats = 23;
     */
    extraSeats;
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.change_subscription_option
     */
    changeSubscriptionOption = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_info", kind: "message", T: PaymentInfo },
        { no: 2, name: "subscription_interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 3, name: "subscription_name_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "product_name_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 22, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "subscription_quota_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "subscription_usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 7, name: "customer_quota_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 8, name: "customer_usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 9, name: "renewal_date_millis", kind: "message", T: Int64Value },
        { no: 10, name: "expiration_date_millis", kind: "message", T: Int64Value },
        { no: 11, name: "discount_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 12, name: "price", kind: "message", T: Money },
        { no: 14, name: "can_downgrade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 15, name: "can_use_voucher", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 16, name: "possible_payment_intervals", kind: "message", T: PaymentInterval, repeated: true },
        { no: 17, name: "credit", kind: "message", T: Money },
        { no: 18, name: "subscription_messages", kind: "message", T: SubscriptionMessage, repeated: true },
        { no: 19, name: "free_storage_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 20, name: "num_family_members", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 21, name: "extra_storage_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
        { no: 23, name: "extra_seats", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 100, name: "normal_upgrade", kind: "message", T: GetPaymentInfoResponse_NormalUpgrade, oneof: "change_subscription_option" },
        { no: 101, name: "manage_in_play_store", kind: "message", T: GetPaymentInfoResponse_ManageInPlayStore, oneof: "change_subscription_option" },
        { no: 102, name: "manage_in_app_store", kind: "message", T: GetPaymentInfoResponse_ManageInAppStore, oneof: "change_subscription_option" },
        { no: 103, name: "contact_reseller", kind: "message", T: GetPaymentInfoResponse_ContactReseller, oneof: "change_subscription_option" },
        { no: 104, name: "contact_support", kind: "message", T: GetPaymentInfoResponse_ContactSupport, oneof: "change_subscription_option" },
        { no: 105, name: "contact_family_owner", kind: "message", T: GetPaymentInfoResponse_ContactFamilyOwner, oneof: "change_subscription_option" },
        { no: 106, name: "contact_business_admin", kind: "message", T: GetPaymentInfoResponse_ContactBusinessAdmin, oneof: "change_subscription_option" },
        { no: 107, name: "manage_in_business_pages", kind: "message", T: GetPaymentInfoResponse_ManageInBusinessPages, oneof: "change_subscription_option" },
        { no: 108, name: "convert_from_reseller", kind: "message", T: GetPaymentInfoResponse_ConvertFromReseller, oneof: "change_subscription_option" },
        { no: 109, name: "manage_subscription_externally", kind: "message", T: GetPaymentInfoResponse_ManageSubscriptionExternally, oneof: "change_subscription_option" },
        { no: 110, name: "sa_subscription", kind: "message", T: GetPaymentInfoResponse_SASubscription, oneof: "change_subscription_option" },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade
 */
export class GetPaymentInfoResponse_NormalUpgrade extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType upgrade_button_hint = 1;
     */
    upgradeButtonHint = GetPaymentInfoResponse_NormalUpgrade_UpgradeType.UPGRADE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "upgrade_button_hint", kind: "enum", T: proto3.getEnumType(GetPaymentInfoResponse_NormalUpgrade_UpgradeType) },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_NormalUpgrade().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_NormalUpgrade().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_NormalUpgrade().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_NormalUpgrade, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType
 */
export var GetPaymentInfoResponse_NormalUpgrade_UpgradeType;
(function (GetPaymentInfoResponse_NormalUpgrade_UpgradeType) {
    /**
     * @generated from enum value: UPGRADE = 0;
     */
    GetPaymentInfoResponse_NormalUpgrade_UpgradeType[GetPaymentInfoResponse_NormalUpgrade_UpgradeType["UPGRADE"] = 0] = "UPGRADE";
    /**
     * @generated from enum value: CHANGE_SUBSCRIPTION = 1;
     */
    GetPaymentInfoResponse_NormalUpgrade_UpgradeType[GetPaymentInfoResponse_NormalUpgrade_UpgradeType["CHANGE_SUBSCRIPTION"] = 1] = "CHANGE_SUBSCRIPTION";
    /**
     * @generated from enum value: NO_UPGRADE_OPTIONS = 2;
     */
    GetPaymentInfoResponse_NormalUpgrade_UpgradeType[GetPaymentInfoResponse_NormalUpgrade_UpgradeType["NO_UPGRADE_OPTIONS"] = 2] = "NO_UPGRADE_OPTIONS";
})(GetPaymentInfoResponse_NormalUpgrade_UpgradeType || (GetPaymentInfoResponse_NormalUpgrade_UpgradeType = {}));
// Retrieve enum metadata with: proto3.getEnumType(GetPaymentInfoResponse_NormalUpgrade_UpgradeType)
proto3.util.setEnumType(GetPaymentInfoResponse_NormalUpgrade_UpgradeType, "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType", [
    { no: 0, name: "UPGRADE" },
    { no: 1, name: "CHANGE_SUBSCRIPTION" },
    { no: 2, name: "NO_UPGRADE_OPTIONS" },
]);
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore
 */
export class GetPaymentInfoResponse_ManageInPlayStore extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ManageInPlayStore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ManageInPlayStore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ManageInPlayStore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ManageInPlayStore, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore
 */
export class GetPaymentInfoResponse_ManageInAppStore extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ManageInAppStore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ManageInAppStore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ManageInAppStore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ManageInAppStore, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller
 */
export class GetPaymentInfoResponse_ContactReseller extends Message {
    /**
     * @generated from field: string reseller_support_url = 1;
     */
    resellerSupportUrl = "";
    /**
     * @generated from field: string reseller_name = 2;
     */
    resellerName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "reseller_support_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "reseller_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ContactReseller().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ContactReseller().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ContactReseller().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ContactReseller, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport
 */
export class GetPaymentInfoResponse_ContactSupport extends Message {
    /**
     * @generated from field: string support_url = 1;
     */
    supportUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "support_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ContactSupport().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ContactSupport().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ContactSupport().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ContactSupport, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner
 */
export class GetPaymentInfoResponse_ContactFamilyOwner extends Message {
    /**
     * @generated from field: string family_owner_name = 1;
     */
    familyOwnerName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "family_owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ContactFamilyOwner().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ContactFamilyOwner().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ContactFamilyOwner().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ContactFamilyOwner, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin
 */
export class GetPaymentInfoResponse_ContactBusinessAdmin extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ContactBusinessAdmin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ContactBusinessAdmin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ContactBusinessAdmin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ContactBusinessAdmin, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages
 */
export class GetPaymentInfoResponse_ManageInBusinessPages extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ManageInBusinessPages().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ManageInBusinessPages().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ManageInBusinessPages().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ManageInBusinessPages, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller
 */
export class GetPaymentInfoResponse_ConvertFromReseller extends Message {
    /**
     * @generated from field: string days_until_termination = 1;
     */
    daysUntilTermination = "";
    /**
     * @generated from field: string reseller_name = 2;
     */
    resellerName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "days_until_termination", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "reseller_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ConvertFromReseller().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ConvertFromReseller().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ConvertFromReseller().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ConvertFromReseller, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally
 */
export class GetPaymentInfoResponse_ManageSubscriptionExternally extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    /**
     * @generated from field: string provider_name = 2;
     */
    providerName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "provider_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_ManageSubscriptionExternally().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_ManageSubscriptionExternally().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_ManageSubscriptionExternally().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_ManageSubscriptionExternally, a, b);
    }
}
/**
 * ServiceAgreement subscription
 *
 * Link to: /web/renew
 *
 * Display button: "Change subscription"
 * Display button: "Register card"
 *
 * @generated from message no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription
 */
export class GetPaymentInfoResponse_SASubscription extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetPaymentInfoResponse_SASubscription().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPaymentInfoResponse_SASubscription().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPaymentInfoResponse_SASubscription().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPaymentInfoResponse_SASubscription, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest
 */
export class GetSupportedPaymentMethodsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetSupportedPaymentMethodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSupportedPaymentMethodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSupportedPaymentMethodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSupportedPaymentMethodsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse
 */
export class GetSupportedPaymentMethodsResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod payment_methods = 1;
     */
    paymentMethods = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_methods", kind: "message", T: GetSupportedPaymentMethodsResponse_PaymentMethod, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetSupportedPaymentMethodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSupportedPaymentMethodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSupportedPaymentMethodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSupportedPaymentMethodsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod
 */
export class GetSupportedPaymentMethodsResponse_PaymentMethod extends Message {
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod";
    static fields = proto3.util.newFieldList(() => [
        { no: 10, name: "stripe", kind: "message", T: GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe, oneof: "type" },
        { no: 11, name: "vipps", kind: "message", T: GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSupportedPaymentMethodsResponse_PaymentMethod, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe
 */
export class GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe extends Message {
    /**
     * @generated from field: string publishable_key = 1;
     */
    publishableKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "publishable_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSupportedPaymentMethodsResponse_PaymentMethod_Stripe, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps
 */
export class GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSupportedPaymentMethodsResponse_PaymentMethod_Vipps, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.StripeClientState
 */
export class StripeClientState extends Message {
    /**
     * @generated from field: string success_path = 1;
     */
    successPath = "";
    /**
     * @generated from field: string failure_path = 2;
     */
    failurePath = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.StripeClientState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "success_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "failure_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new StripeClientState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StripeClientState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StripeClientState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StripeClientState, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderRequest
 */
export class PlaceOrderRequest extends Message {
    /**
     * @generated from field: string product_code = 1;
     */
    productCode = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval subscription_interval = 2;
     */
    subscriptionInterval = SubscriptionInterval.NOT_SET;
    /**
     * @generated from field: optional uint32 extra_storage_tb = 3;
     */
    extraStorageTb;
    /**
     * @generated from field: optional uint32 extra_user_seats = 4;
     */
    extraUserSeats;
    /**
     * @generated from field: optional string voucher_code = 5;
     */
    voucherCode;
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.PlaceOrderRequest.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "subscription_interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 3, name: "extra_storage_tb", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 4, name: "extra_user_seats", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 5, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 10, name: "stripe", kind: "message", T: PlaceOrderRequest_Stripe, oneof: "type" },
        { no: 11, name: "vipps", kind: "message", T: PlaceOrderRequest_Vipps, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe
 */
export class PlaceOrderRequest_Stripe extends Message {
    /**
     * @generated from field: optional string new_payment_method_id = 1;
     */
    newPaymentMethodId;
    /**
     * @generated from field: optional no.jotta.openapi.subscription.v2.StripeClientState client_state = 2;
     */
    clientState;
    /**
     * @generated from field: string redirect_hostname = 3;
     */
    redirectHostname = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "new_payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 2, name: "client_state", kind: "message", T: StripeClientState, opt: true },
        { no: 3, name: "redirect_hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderRequest_Stripe().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderRequest_Stripe().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderRequest_Stripe().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderRequest_Stripe, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps
 */
export class PlaceOrderRequest_Vipps extends Message {
    /**
     * This is the url we will send the browser to eventually
     *
     * @generated from field: string redirect_url = 1;
     */
    redirectUrl = "";
    /**
     * optional: failure_redirect_url: when you want cancel/failed signature to go to a separate url.
     *
     * @generated from field: optional string failure_redirect_url = 2;
     */
    failureRedirectUrl;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "failure_redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderRequest_Vipps().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderRequest_Vipps().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderRequest_Vipps().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderRequest_Vipps, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderResponse
 */
export class PlaceOrderResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.PlaceOrderResponse.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 10, name: "stripe", kind: "message", T: PlaceOrderResponse_Stripe, oneof: "type" },
        { no: 11, name: "vipps", kind: "message", T: PlaceOrderResponse_Vipps, oneof: "type" },
        { no: 12, name: "rejected", kind: "message", T: PlaceOrderResponse_Rejected, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe
 */
export class PlaceOrderResponse_Stripe extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderResponse_Stripe().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderResponse_Stripe().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderResponse_Stripe().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderResponse_Stripe, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps
 */
export class PlaceOrderResponse_Vipps extends Message {
    /**
     * Vipps url to send the customer to for payment
     *
     * @generated from field: string confirmation_url = 1;
     */
    confirmationUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "confirmation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderResponse_Vipps().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderResponse_Vipps().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderResponse_Vipps().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderResponse_Vipps, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected
 */
export class PlaceOrderResponse_Rejected extends Message {
    /**
     * @generated from field: string message = 1;
     */
    message = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PlaceOrderResponse_Rejected().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOrderResponse_Rejected().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOrderResponse_Rejected().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOrderResponse_Rejected, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest
 */
export class CheckAndConfirmStripeRequest extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse
 */
export class CheckAndConfirmStripeResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 10, name: "success", kind: "message", T: CheckAndConfirmStripeResponse_Success, oneof: "status" },
        { no: 11, name: "card_action_required", kind: "message", T: CheckAndConfirmStripeResponse_CardActionRequired, oneof: "status" },
        { no: 12, name: "card_setup_required", kind: "message", T: CheckAndConfirmStripeResponse_CardSetupRequired, oneof: "status" },
        { no: 14, name: "redirect_required", kind: "message", T: CheckAndConfirmStripeResponse_RedirectRequired, oneof: "status" },
        { no: 13, name: "rejected", kind: "message", T: CheckAndConfirmStripeResponse_Rejected, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success
 */
export class CheckAndConfirmStripeResponse_Success extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse_Success().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse_Success().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse_Success().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse_Success, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired
 */
export class CheckAndConfirmStripeResponse_CardActionRequired extends Message {
    /**
     * @generated from field: string client_secret = 1;
     */
    clientSecret = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse_CardActionRequired().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse_CardActionRequired().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse_CardActionRequired().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse_CardActionRequired, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired
 */
export class CheckAndConfirmStripeResponse_CardSetupRequired extends Message {
    /**
     * @generated from field: string client_secret = 1;
     */
    clientSecret = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse_CardSetupRequired().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse_CardSetupRequired().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse_CardSetupRequired().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse_CardSetupRequired, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired
 */
export class CheckAndConfirmStripeResponse_RedirectRequired extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse_RedirectRequired().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse_RedirectRequired().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse_RedirectRequired().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse_RedirectRequired, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected
 */
export class CheckAndConfirmStripeResponse_Rejected extends Message {
    /**
     * @generated from field: string message = 1;
     */
    message = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckAndConfirmStripeResponse_Rejected().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckAndConfirmStripeResponse_Rejected().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckAndConfirmStripeResponse_Rejected().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckAndConfirmStripeResponse_Rejected, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.OrderItem
 */
export class OrderItem extends Message {
    /**
     * @generated from field: string product_code = 1;
     */
    productCode = "";
    /**
     * @generated from field: string localized_name = 2;
     */
    localizedName = "";
    /**
     * @generated from field: int32 quantity = 3;
     */
    quantity = 0;
    /**
     * @generated from field: int64 price_cents = 4;
     */
    priceCents = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.OrderItem";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "localized_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 4, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new OrderItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrderItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrderItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrderItem, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.Order
 */
export class Order extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    /**
     * @generated from field: int64 timestamp_millis = 2;
     */
    timestampMillis = protoInt64.zero;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Order.OrderStatus status = 3;
     */
    status = Order_OrderStatus.UNKNOWN_ORDER_STATUS;
    /**
     * @generated from field: string status_localized = 19;
     */
    statusLocalized = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Order.OrderType type = 4;
     */
    type = Order_OrderType.UNKNOWN_ORDER_TYPE;
    /**
     * @generated from field: string type_localized = 20;
     */
    typeLocalized = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 7;
     */
    interval = SubscriptionInterval.NOT_SET;
    /**
     * @generated from field: string localized_description = 8;
     */
    localizedDescription = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Currency currency = 6;
     */
    currency = Currency.UNKNOWN_CURRENCY;
    /**
     * @generated from field: int64 price_cents = 9;
     */
    priceCents = protoInt64.zero;
    /**
     * @generated from field: int64 vat_amount_cents = 10;
     */
    vatAmountCents = protoInt64.zero;
    /**
     * @generated from field: int64 credit_used_cents = 11;
     */
    creditUsedCents = protoInt64.zero;
    /**
     * @generated from field: int64 charged_cents = 12;
     */
    chargedCents = protoInt64.zero;
    /**
     * @generated from field: int64 discount_amount_cents = 13;
     */
    discountAmountCents = protoInt64.zero;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Card card = 14;
     */
    card;
    /**
     * @generated from field: string billed_to_name = 15;
     */
    billedToName = "";
    /**
     * @generated from field: string billed_to_email = 16;
     */
    billedToEmail = "";
    /**
     * @generated from field: string receipt_link = 17;
     */
    receiptLink = "";
    /**
     * @generated from field: string encoded_content_ref = 18;
     */
    encodedContentRef = "";
    /**
     * @generated from field: repeated no.jotta.openapi.subscription.v2.OrderItem order_items = 100;
     */
    orderItems = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.Order";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "timestamp_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(Order_OrderStatus) },
        { no: 19, name: "status_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Order_OrderType) },
        { no: 20, name: "type_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 8, name: "localized_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "currency", kind: "enum", T: proto3.getEnumType(Currency) },
        { no: 9, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 10, name: "vat_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 11, name: "credit_used_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 12, name: "charged_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 13, name: "discount_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 14, name: "card", kind: "message", T: Card },
        { no: 15, name: "billed_to_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 16, name: "billed_to_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 17, name: "receipt_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 18, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 100, name: "order_items", kind: "message", T: OrderItem, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new Order().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Order().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Order().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Order, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.subscription.v2.Order.OrderStatus
 */
export var Order_OrderStatus;
(function (Order_OrderStatus) {
    /**
     * @generated from enum value: UNKNOWN_ORDER_STATUS = 0;
     */
    Order_OrderStatus[Order_OrderStatus["UNKNOWN_ORDER_STATUS"] = 0] = "UNKNOWN_ORDER_STATUS";
    /**
     * @generated from enum value: PENDING = 1;
     */
    Order_OrderStatus[Order_OrderStatus["PENDING"] = 1] = "PENDING";
    /**
     * @generated from enum value: CREATED = 2;
     */
    Order_OrderStatus[Order_OrderStatus["CREATED"] = 2] = "CREATED";
    /**
     * @generated from enum value: PROCESSING = 3;
     */
    Order_OrderStatus[Order_OrderStatus["PROCESSING"] = 3] = "PROCESSING";
    /**
     * @generated from enum value: COMPLETED = 4;
     */
    Order_OrderStatus[Order_OrderStatus["COMPLETED"] = 4] = "COMPLETED";
    /**
     * @generated from enum value: REJECTED = 5;
     */
    Order_OrderStatus[Order_OrderStatus["REJECTED"] = 5] = "REJECTED";
    /**
     * @generated from enum value: CANCELLED = 6;
     */
    Order_OrderStatus[Order_OrderStatus["CANCELLED"] = 6] = "CANCELLED";
    /**
     * @generated from enum value: FAILED = 7;
     */
    Order_OrderStatus[Order_OrderStatus["FAILED"] = 7] = "FAILED";
    /**
     * @generated from enum value: REFUNDED = 8;
     */
    Order_OrderStatus[Order_OrderStatus["REFUNDED"] = 8] = "REFUNDED";
    /**
     * @generated from enum value: PARTIALLY_REFUNDED = 9;
     */
    Order_OrderStatus[Order_OrderStatus["PARTIALLY_REFUNDED"] = 9] = "PARTIALLY_REFUNDED";
})(Order_OrderStatus || (Order_OrderStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(Order_OrderStatus)
proto3.util.setEnumType(Order_OrderStatus, "no.jotta.openapi.subscription.v2.Order.OrderStatus", [
    { no: 0, name: "UNKNOWN_ORDER_STATUS" },
    { no: 1, name: "PENDING" },
    { no: 2, name: "CREATED" },
    { no: 3, name: "PROCESSING" },
    { no: 4, name: "COMPLETED" },
    { no: 5, name: "REJECTED" },
    { no: 6, name: "CANCELLED" },
    { no: 7, name: "FAILED" },
    { no: 8, name: "REFUNDED" },
    { no: 9, name: "PARTIALLY_REFUNDED" },
]);
/**
 * @generated from enum no.jotta.openapi.subscription.v2.Order.OrderType
 */
export var Order_OrderType;
(function (Order_OrderType) {
    /**
     * @generated from enum value: UNKNOWN_ORDER_TYPE = 0;
     */
    Order_OrderType[Order_OrderType["UNKNOWN_ORDER_TYPE"] = 0] = "UNKNOWN_ORDER_TYPE";
    /**
     * @generated from enum value: RENEWAL = 1;
     */
    Order_OrderType[Order_OrderType["RENEWAL"] = 1] = "RENEWAL";
    /**
     * @generated from enum value: BUY = 2;
     */
    Order_OrderType[Order_OrderType["BUY"] = 2] = "BUY";
    /**
     * @generated from enum value: CREDIT_NOTE = 3;
     */
    Order_OrderType[Order_OrderType["CREDIT_NOTE"] = 3] = "CREDIT_NOTE";
    /**
     * @generated from enum value: SA = 4;
     */
    Order_OrderType[Order_OrderType["SA"] = 4] = "SA";
    /**
     * @generated from enum value: SA_PROLONGED = 5;
     */
    Order_OrderType[Order_OrderType["SA_PROLONGED"] = 5] = "SA_PROLONGED";
    /**
     * @generated from enum value: RTG = 6;
     */
    Order_OrderType[Order_OrderType["RTG"] = 6] = "RTG";
    /**
     * @generated from enum value: PROLONGED = 7;
     */
    Order_OrderType[Order_OrderType["PROLONGED"] = 7] = "PROLONGED";
    /**
     * @generated from enum value: VOUCHER = 8;
     */
    Order_OrderType[Order_OrderType["VOUCHER"] = 8] = "VOUCHER";
    /**
     * @generated from enum value: VOUCHER_PROLONGED = 9;
     */
    Order_OrderType[Order_OrderType["VOUCHER_PROLONGED"] = 9] = "VOUCHER_PROLONGED";
    /**
     * @generated from enum value: INVITE = 10;
     */
    Order_OrderType[Order_OrderType["INVITE"] = 10] = "INVITE";
    /**
     * @generated from enum value: CCCHANGE = 11;
     */
    Order_OrderType[Order_OrderType["CCCHANGE"] = 11] = "CCCHANGE";
    /**
     * @generated from enum value: FREE_BASE = 12;
     */
    Order_OrderType[Order_OrderType["FREE_BASE"] = 12] = "FREE_BASE";
    /**
     * @generated from enum value: BUSINESS_BASE = 13;
     */
    Order_OrderType[Order_OrderType["BUSINESS_BASE"] = 13] = "BUSINESS_BASE";
    /**
     * @generated from enum value: FAMILY_MEMBER_BASE = 14;
     */
    Order_OrderType[Order_OrderType["FAMILY_MEMBER_BASE"] = 14] = "FAMILY_MEMBER_BASE";
    /**
     * @generated from enum value: SYSTEM_FORCED = 15;
     */
    Order_OrderType[Order_OrderType["SYSTEM_FORCED"] = 15] = "SYSTEM_FORCED";
    /**
     * @generated from enum value: EXPIRE_CHANGE = 16;
     */
    Order_OrderType[Order_OrderType["EXPIRE_CHANGE"] = 16] = "EXPIRE_CHANGE";
    /**
     * @generated from enum value: DUE_FOR_TERMINATION = 17;
     */
    Order_OrderType[Order_OrderType["DUE_FOR_TERMINATION"] = 17] = "DUE_FOR_TERMINATION";
    /**
     * @generated from enum value: INTERVAL_CHANGE = 18;
     */
    Order_OrderType[Order_OrderType["INTERVAL_CHANGE"] = 18] = "INTERVAL_CHANGE";
    /**
     * @generated from enum value: IAP_END = 19;
     */
    Order_OrderType[Order_OrderType["IAP_END"] = 19] = "IAP_END";
})(Order_OrderType || (Order_OrderType = {}));
// Retrieve enum metadata with: proto3.getEnumType(Order_OrderType)
proto3.util.setEnumType(Order_OrderType, "no.jotta.openapi.subscription.v2.Order.OrderType", [
    { no: 0, name: "UNKNOWN_ORDER_TYPE" },
    { no: 1, name: "RENEWAL" },
    { no: 2, name: "BUY" },
    { no: 3, name: "CREDIT_NOTE" },
    { no: 4, name: "SA" },
    { no: 5, name: "SA_PROLONGED" },
    { no: 6, name: "RTG" },
    { no: 7, name: "PROLONGED" },
    { no: 8, name: "VOUCHER" },
    { no: 9, name: "VOUCHER_PROLONGED" },
    { no: 10, name: "INVITE" },
    { no: 11, name: "CCCHANGE" },
    { no: 12, name: "FREE_BASE" },
    { no: 13, name: "BUSINESS_BASE" },
    { no: 14, name: "FAMILY_MEMBER_BASE" },
    { no: 15, name: "SYSTEM_FORCED" },
    { no: 16, name: "EXPIRE_CHANGE" },
    { no: 17, name: "DUE_FOR_TERMINATION" },
    { no: 18, name: "INTERVAL_CHANGE" },
    { no: 19, name: "IAP_END" },
]);
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetOrderRequest
 */
export class GetOrderRequest extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetOrderRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOrderRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.GetOrderResponse
 */
export class GetOrderResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Order order = 1;
     */
    order;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.GetOrderResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order", kind: "message", T: Order },
    ]);
    static fromBinary(bytes, options) {
        return new GetOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOrderResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.ListOrdersRequest
 */
export class ListOrdersRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ListOrdersRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListOrdersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrdersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrdersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrdersRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.ListOrdersResponse
 */
export class ListOrdersResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.subscription.v2.Order orders = 1;
     */
    orders = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ListOrdersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListOrdersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOrdersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOrdersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOrdersResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.DescribeVoucherRequest
 */
export class DescribeVoucherRequest extends Message {
    /**
     * @generated from field: string code = 1;
     */
    code = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.DescribeVoucherRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DescribeVoucherRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.DescribeVoucherResponse
 */
export class DescribeVoucherResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus status = 1;
     */
    status = DescribeVoucherResponse_VoucherStatus.UNKNOWN_STATUS;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction action = 2;
     */
    action = DescribeVoucherResponse_VoucherAction.UNKNOWN_ACTION;
    /**
     * @generated from field: int32 discount_percentage = 3;
     */
    discountPercentage = 0;
    /**
     * @generated from field: double credit = 4;
     */
    credit = 0;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval duration = 5;
     */
    duration = SubscriptionInterval.NOT_SET;
    /**
     * @generated from field: string product_message_key = 6;
     */
    productMessageKey = "";
    /**
     * @generated from field: int64 renewal_expire_time_millis = 7;
     */
    renewalExpireTimeMillis = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.DescribeVoucherResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(DescribeVoucherResponse_VoucherStatus) },
        { no: 2, name: "action", kind: "enum", T: proto3.getEnumType(DescribeVoucherResponse_VoucherAction) },
        { no: 3, name: "discount_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 4, name: "credit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 5, name: "duration", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 6, name: "product_message_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "renewal_expire_time_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new DescribeVoucherResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus
 */
export var DescribeVoucherResponse_VoucherStatus;
(function (DescribeVoucherResponse_VoucherStatus) {
    /**
     * @generated from enum value: UNKNOWN_STATUS = 0;
     */
    DescribeVoucherResponse_VoucherStatus[DescribeVoucherResponse_VoucherStatus["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
    /**
     * @generated from enum value: OPEN = 1;
     */
    DescribeVoucherResponse_VoucherStatus[DescribeVoucherResponse_VoucherStatus["OPEN"] = 1] = "OPEN";
    /**
     * @generated from enum value: NOT_FOUND = 2;
     */
    DescribeVoucherResponse_VoucherStatus[DescribeVoucherResponse_VoucherStatus["NOT_FOUND"] = 2] = "NOT_FOUND";
    /**
     * @generated from enum value: EXPIRED = 3;
     */
    DescribeVoucherResponse_VoucherStatus[DescribeVoucherResponse_VoucherStatus["EXPIRED"] = 3] = "EXPIRED";
    /**
     * @generated from enum value: USED = 4;
     */
    DescribeVoucherResponse_VoucherStatus[DescribeVoucherResponse_VoucherStatus["USED"] = 4] = "USED";
})(DescribeVoucherResponse_VoucherStatus || (DescribeVoucherResponse_VoucherStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(DescribeVoucherResponse_VoucherStatus)
proto3.util.setEnumType(DescribeVoucherResponse_VoucherStatus, "no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus", [
    { no: 0, name: "UNKNOWN_STATUS" },
    { no: 1, name: "OPEN" },
    { no: 2, name: "NOT_FOUND" },
    { no: 3, name: "EXPIRED" },
    { no: 4, name: "USED" },
]);
/**
 * @generated from enum no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction
 */
export var DescribeVoucherResponse_VoucherAction;
(function (DescribeVoucherResponse_VoucherAction) {
    /**
     * @generated from enum value: UNKNOWN_ACTION = 0;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["UNKNOWN_ACTION"] = 0] = "UNKNOWN_ACTION";
    /**
     * @generated from enum value: NEW_SUBSCRIPTION = 1;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["NEW_SUBSCRIPTION"] = 1] = "NEW_SUBSCRIPTION";
    /**
     * @generated from enum value: EXTEND_RENEWAL = 2;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["EXTEND_RENEWAL"] = 2] = "EXTEND_RENEWAL";
    /**
     * @generated from enum value: EXTEND_EXPIRE = 3;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["EXTEND_EXPIRE"] = 3] = "EXTEND_EXPIRE";
    /**
     * @generated from enum value: NO_CHANGE = 4;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["NO_CHANGE"] = 4] = "NO_CHANGE";
    /**
     * @generated from enum value: NEW_RECURRING_SUBSCRIPTION = 5;
     */
    DescribeVoucherResponse_VoucherAction[DescribeVoucherResponse_VoucherAction["NEW_RECURRING_SUBSCRIPTION"] = 5] = "NEW_RECURRING_SUBSCRIPTION";
})(DescribeVoucherResponse_VoucherAction || (DescribeVoucherResponse_VoucherAction = {}));
// Retrieve enum metadata with: proto3.getEnumType(DescribeVoucherResponse_VoucherAction)
proto3.util.setEnumType(DescribeVoucherResponse_VoucherAction, "no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction", [
    { no: 0, name: "UNKNOWN_ACTION" },
    { no: 1, name: "NEW_SUBSCRIPTION" },
    { no: 2, name: "EXTEND_RENEWAL" },
    { no: 3, name: "EXTEND_EXPIRE" },
    { no: 4, name: "NO_CHANGE" },
    { no: 5, name: "NEW_RECURRING_SUBSCRIPTION" },
]);
/**
 * @generated from message no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest
 */
export class CancelPaymentTicketRequest extends Message {
    /**
     * @generated from field: string payment_ticket_id = 1;
     */
    paymentTicketId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payment_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CancelPaymentTicketRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelPaymentTicketRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelPaymentTicketRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelPaymentTicketRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse
 */
export class CancelPaymentTicketResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CancelPaymentTicketResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelPaymentTicketResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelPaymentTicketResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelPaymentTicketResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.ApplyVoucherRequest
 */
export class ApplyVoucherRequest extends Message {
    /**
     * @generated from field: string code = 1;
     */
    code = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ApplyVoucherRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ApplyVoucherRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyVoucherRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyVoucherRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyVoucherRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.ApplyVoucherResponse
 */
export class ApplyVoucherResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.ApplyVoucherResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ApplyVoucherResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyVoucherResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyVoucherResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyVoucherResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CreateVippsIntentRequest
 */
export class CreateVippsIntentRequest extends Message {
    /**
     * Hint to Vipps if the customer is paying from web or from inside a mobile app
     *
     * @generated from field: bool is_app = 1;
     */
    isApp = false;
    /**
     * This is the url we will send the browser to eventually
     *
     * @generated from field: string redirect_url = 2;
     */
    redirectUrl = "";
    /**
     * The interval you want to change to. Leave blank for no change.
     * This is needed as you can not modify interval on an existing Vipps agreement,
     * so we must sign a new agreement with the wanted interval.
     *
     * @generated from field: no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 3;
     */
    interval = SubscriptionInterval.NOT_SET;
    /**
     * optional: failure_redirect_url: when you want cancel/failed signature to go to a separate url.
     *
     * @generated from field: string failure_redirect_url = 4;
     */
    failureRedirectUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreateVippsIntentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "is_app", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "interval", kind: "enum", T: proto3.getEnumType(SubscriptionInterval) },
        { no: 4, name: "failure_redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateVippsIntentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateVippsIntentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateVippsIntentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateVippsIntentRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.subscription.v2.CreateVippsIntentResponse
 */
export class CreateVippsIntentResponse extends Message {
    /**
     * Vipps url to send the customer to for payment
     *
     * @generated from field: string confirmation_url = 1;
     */
    confirmationUrl = "";
    /**
     * Our internal payment_ticket_id.
     * Can be used to poll for updates on the ticket coupled to the agreement returned in this response.
     *
     * @generated from field: string payment_ticket_id = 2;
     */
    paymentTicketId = "";
    /**
     * Vipps agreement id
     *
     * session_id can be used to identify this stateful session,
     * to continue the process after coming back from the redirect.
     * string session_id = 4;
     *
     * @generated from field: string agreement_id = 3;
     */
    agreementId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.subscription.v2.CreateVippsIntentResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "confirmation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "payment_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "agreement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateVippsIntentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateVippsIntentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateVippsIntentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateVippsIntentResponse, a, b);
    }
}
